import { isRecord } from '@/helpers/isRecord'
import { NotificationTappedPayload } from '@/types'

export const isNotificationTappedPayload = (value: unknown): value is NotificationTappedPayload => (
    isRecord(value) && (value.route === undefined || typeof value.route === 'string')
)
